import React, { useEffect, useMemo, useState } from "react";
import TraineeHeader from "../Trainee/TraineeHeader";
import TraineeCatalogHero from "../Trainee/TraineeCatalogHero";
import InternshipHeader from "../Home/InternshipHeader";
import Footers from "../Home/Footers";
import "./Internship.css";
import "../Home/publicPages.css";
import "../Home/catalogHero.css";
import AxiosInstance from "../Home/AxiosInstance"
import { storeTokens, buildTraineeSignInPayload } from "../Home/auth";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FiX,
  FiSearch,
  FiMapPin,
  FiClock,
  FiBriefcase,
  FiHome,
} from "react-icons/fi";
import { HiOutlineCurrencyRupee } from "react-icons/hi";
import {
  CatalogFilters,
  FilterOptionList,
  FilterPayRanges,
  toggleFilterValue,
  buildInternshipFilterOptions,
  matchesExactValues,
  matchesStipendRanges,
} from "../Home/CatalogFilters";

export default function Internship() {
  const [internships, setInternships] = useState([]);
  const [filteredInternships, setFilteredInternships] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [searchRole, setSearchRole] = useState("");
  const [searchLocation, setSearchLocation] = useState("");

  const [tempSearchRole, setTempSearchRole] = useState("");
  const [tempSearchLocation, setTempSearchLocation] = useState("");

  const [filterRoles, setFilterRoles] = useState([]);
  const [filterWorkModes, setFilterWorkModes] = useState([]);
  const [filterTypes, setFilterTypes] = useState([]);
  const [filterLocations, setFilterLocations] = useState([]);
  const [filterDurations, setFilterDurations] = useState([]);
  const [filterCompanyTypes, setFilterCompanyTypes] = useState([]);
  const [filterDepartments, setFilterDepartments] = useState([]);
  const [filterEducations, setFilterEducations] = useState([]);
  const [filterStipends, setFilterStipends] = useState([]);
  const [educationOptions, setEducationOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const isFromTraineeProfile =
    location.state?.from === "trainee-profile" ||
    Boolean(localStorage.getItem("traineeId"));

  const [showModal, setShowModal] = useState(false);
  const [selectedInternship, setSelectedInternship] = useState(null);
  const [hasApplied, setHasApplied] = useState(false);
  const [appliedInternshipIds, setAppliedInternshipIds] = useState(
    () => new Set()
  );

  const [traineeId, setTraineeId] = useState(() => {
    const storedId = localStorage.getItem("traineeId");
    return storedId ? parseInt(storedId) : null;
  });

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    name: "",
    resume: null,
  });

  const [isSigningIn, setIsSigningIn] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const availableFilters = useMemo(
    () =>
      buildInternshipFilterOptions(internships, {
        educationOptions,
        departmentOptions,
      }),
    [internships, educationOptions, departmentOptions]
  );

useEffect(() => {
  const fetchInternships = async () => {
    try {
      const response = await AxiosInstance.get("companies/internships/");
      const data = response.data;

      setInternships(data);
      setFilteredInternships(data);
      setLoading(false);
      setError(null); // Clear any previous errors
    } catch (error) {
      // On error, show "no internships found" instead of error message
      setInternships([]);
      setFilteredInternships([]);
      setLoading(false);
      setError(null); // Don't set error, just show empty state
    }
  };

  fetchInternships();
}, []);

useEffect(() => {
  AxiosInstance.get("companies/educations/")
    .then((res) => {
      setEducationOptions(Array.isArray(res.data) ? res.data : []);
    })
    .catch(() => setEducationOptions([]));

  AxiosInstance.get("companies/departments/")
    .then((res) => {
      setDepartmentOptions(Array.isArray(res.data) ? res.data : []);
    })
    .catch(() => setDepartmentOptions([]));
}, []);

  useEffect(() => {
    if (!traineeId) {
      setAppliedInternshipIds(new Set());
      return;
    }
    AxiosInstance.get(`companies/applications/${traineeId}/`)
      .then((res) => {
        const ids = new Set(
          (Array.isArray(res.data) ? res.data : [])
            .map((app) => app.internship?.internship_id ?? app.internship)
            .filter(Boolean)
            .map((id) => Number(id))
        );
        setAppliedInternshipIds(ids);
      })
      .catch(() => setAppliedInternshipIds(new Set()));
  }, [traineeId]);

  useEffect(() => {
    const filtered = internships.filter((internship) => {
      const roleMatch = internship.role
        ?.toLowerCase()
        .includes(searchRole.toLowerCase());
      const locationSearchMatch = internship.location
        ?.toLowerCase()
        .includes(searchLocation.toLowerCase());

      return (
        roleMatch &&
        locationSearchMatch &&
        matchesExactValues(internship.role, filterRoles) &&
        matchesExactValues(internship.work_mode, filterWorkModes) &&
        matchesExactValues(internship.internship_type, filterTypes) &&
        matchesExactValues(internship.location, filterLocations) &&
        matchesExactValues(internship.duration, filterDurations) &&
        matchesExactValues(
          internship.company?.business_type?.business_type ||
            internship.company?.business_type ||
            "",
          filterCompanyTypes
        ) &&
        matchesExactValues(internship.department, filterDepartments) &&
        matchesExactValues(internship.education, filterEducations) &&
        matchesStipendRanges(internship.stipend, filterStipends)
      );
    });

    setFilteredInternships(filtered);
  }, [
    searchRole,
    searchLocation,
    internships,
    filterRoles,
    filterWorkModes,
    filterTypes,
    filterLocations,
    filterDurations,
    filterCompanyTypes,
    filterDepartments,
    filterEducations,
    filterStipends,
  ]);

  const handleSearch = () => {
    setSearchRole(tempSearchRole);
    setSearchLocation(tempSearchLocation);
  };

  const handleCardClick = (id) => {
    navigate(`/internships/${id}`, {
      state: { from: location.state?.from }, // forward the state
    });
  };

  const clearRoleSearch = () => {
    setTempSearchRole("");
    setSearchRole("");
  };

  const clearLocationSearch = () => {
    setTempSearchLocation("");
    setSearchLocation("");
  };

  const clearFilterInputs = () => {
    setFilterRoles([]);
    setFilterWorkModes([]);
    setFilterTypes([]);
    setFilterLocations([]);
    setFilterDurations([]);
    setFilterCompanyTypes([]);
    setFilterDepartments([]);
    setFilterEducations([]);
    setFilterStipends([]);
    setTempSearchRole("");
    setTempSearchLocation("");
    setSearchRole("");
    setSearchLocation("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, resume: e.target.files[0] }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const { email, password, confirmPassword, name, resume } = formData;

    if (!traineeId) {
      if (isSigningIn) {
        if (!email || !password) {
          setErrorMessage("Please enter email or mobile number and password.");
          return;
        }
        try {
          const res = await AxiosInstance.post(
            "companies/signin",
            buildTraineeSignInPayload(email, password)
          );

          const idReceived = res.data.trainee?.trainee_id;
          if (!idReceived) {
            setErrorMessage("Sign-in failed: trainee_id not received.");
            return;
          }

          const parsedId = parseInt(idReceived);
          setTraineeId(parsedId);
          storeTokens(res.data);
          localStorage.setItem("traineeId", parsedId);
          setErrorMessage("");
          try {
            const appRes = await AxiosInstance.get(
              `companies/application/${selectedInternship?.internship_id}/`
            );
            const applications = appRes.data;
            const alreadyApplied = applications.some(
              (app) => app.trainee?.trainee_id === parsedId
            );

            if (alreadyApplied) {
              navigate("/trainee-profile");
              return;
            }
          } catch (err) {
            console.error(
              "Error checking application status after sign-in",
              err
            );
          }
          setFormData((prev) => ({
            ...prev,
            password: "",
            confirmPassword: "",
          }));
        } catch (err) {
          console.error(err);
          setErrorMessage(err.response?.data?.error || "Sign-in failed.");
          return;
        }
      } else {
        if (!email || !password || !confirmPassword) {
          setErrorMessage("Please fill all fields.");
          return;
        }
        if (password !== confirmPassword) {
          setErrorMessage("Passwords do not match.");
          return;
        }
        if (formData.password.length < 6) {
          setErrorMessage("Password must be at least 6 characters long");
          return;
        }

        try {
          const res = await AxiosInstance.post(
            "companies/signup",
            {
              email,
              password,
              confirm_password: confirmPassword,
              first_name: formData.first_name,
              last_name: formData.last_name,
              mobile_no: formData.mobile_no,
            }
          );

          const idReceived = res.data.trainee_id;
          if (!idReceived) {
            alert("Signup failed: trainee_id not received.");
            return;
          }

          const parsedId = parseInt(idReceived);
          setTraineeId(parsedId);
          storeTokens(res.data);
          localStorage.setItem("traineeId", parsedId);
          setFormData((prev) => ({
            ...prev,
            password: "",
            confirmPassword: "",
            first_name: "",
            last_name: "",
            mobile_no: "",
          }));
          setErrorMessage("");
        } catch (err) {
          console.error(err);
          const errorData = err.response?.data?.error;
          let errorMessage = "Signup failed.";

          if (typeof errorData === "string") {
            errorMessage = errorData;
          } else if (typeof errorData === "object") {
            errorMessage = Object.entries(errorData)
              .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
              .join("\n");
          }
          setErrorMessage(errorMessage);
        }
      }
    } else {
      // Application submission
      if ( !resume) {
        setErrorMessage("Please upload your resume.");
        return;
      }

      const [firstName, ...lastParts] = name.trim().split(" ");
      const lastName = lastParts.join(" ") || "-";

      const data = new FormData();
      data.append("trainee", traineeId);
      data.append("internship", selectedInternship?.internship_id);
      data.append("first_name", firstName);
      data.append("last_name", lastName);
      data.append("resume_path", resume);

      try {
        await AxiosInstance.post("companies/application/", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        alert("Application submitted successfully!");
        setShowModal(false);
        setFormData({
          email: "",
          password: "",
          confirmPassword: "",
          name: "",
          resume: null,
        });
        setHasApplied(true);
        if (selectedInternship?.internship_id) {
          setAppliedInternshipIds((prev) => {
            const next = new Set(prev);
            next.add(Number(selectedInternship.internship_id));
            return next;
          });
        }
        setErrorMessage("");
        navigate("/trainee-profile");
      } catch (err) {
        console.error(err);
        const errorMessage =
          err.response?.data?.error ||
          (typeof err.response?.data === "object"
            ? JSON.stringify(err.response.data)
            : err.response?.data || "Application submission failed.");
        setErrorMessage(errorMessage);
      }
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setIsSigningIn(true);
    setFormData({
      email: "",
      password: "",
      confirmPassword: "",
      name: "",
      resume: null,
    });
    setErrorMessage("");
  };

  const skillList = (skills) => {
    if (!skills) return [];
    return skills
      .split(/[,|]/)
      .map((s) => s.trim())
      .filter(Boolean)
      .slice(0, 5);
  };

  return (
    <div className="InternshipPage min-vh-100 d-flex flex-column">
      {isFromTraineeProfile ? <TraineeHeader /> : <InternshipHeader />}
      {isFromTraineeProfile && (
        <TraineeCatalogHero
          eyebrow="Internships"
          title="Real experience. Real impact."
          subtitle="Discover real-world roles from top companies and take the next step in your career."
        />
      )}
      {!isFromTraineeProfile && (
        <div className="als-page-hero als-hero-split">
          <div className="als-page-hero-inner">
            <div className="als-hero-copy">
              <h1>Real experience. Real impact.</h1>
              <p>
                Discover real-world roles from top companies and take the next
                step in your career.
              </p>
            </div>
            <div className="als-hero-media">
              <img
                src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800&h=520&fit=crop"
                alt="Professionals collaborating"
              />
            </div>
          </div>
        </div>
      )}

      <div
        className={`is-catalog flex-grow-1${
          isFromTraineeProfile ? " is-catalog--trainee" : ""
        }`}
      >
        <div className="is-catalog-inner">
          <form
            className="is-search-bar"
            onSubmit={(e) => {
              e.preventDefault();
              handleSearch();
            }}
          >
            <div className="is-search-field">
              <FiSearch className="is-search-icon" />
              <input
                type="text"
                placeholder="Search by role or keyword"
                value={tempSearchRole}
                onChange={(e) => setTempSearchRole(e.target.value)}
              />
              {tempSearchRole && (
                <button
                  type="button"
                  className="clear-input"
                  onClick={clearRoleSearch}
                  aria-label="Clear role search"
                >
                  <FiX />
                </button>
              )}
            </div>
            <div className="is-search-field is-search-location">
              <FiMapPin className="is-search-icon" />
              <input
                type="text"
                placeholder="City or remote"
                value={tempSearchLocation}
                onChange={(e) => setTempSearchLocation(e.target.value)}
              />
              {tempSearchLocation && (
                <button
                  type="button"
                  className="clear-input"
                  onClick={clearLocationSearch}
                  aria-label="Clear location"
                >
                  <FiX />
                </button>
              )}
            </div>
            <button type="submit" className="is-search-btn">
              Search
            </button>
          </form>

          <div className="is-layout">
            <CatalogFilters onClear={clearFilterInputs}>
              <FilterOptionList
                title="Work mode"
                options={availableFilters.workModes}
                selected={filterWorkModes}
                onToggle={(key) =>
                  setFilterWorkModes((prev) => toggleFilterValue(prev, key))
                }
              />
              {availableFilters.stipends.length > 0 && (
                <FilterPayRanges
                  title="Stipend"
                  options={availableFilters.stipends}
                  selected={filterStipends}
                  onToggle={(key) =>
                    setFilterStipends((prev) => toggleFilterValue(prev, key))
                  }
                />
              )}
              {availableFilters.locations.length > 0 && (
                <FilterOptionList
                  title="Location"
                  options={availableFilters.locations}
                  selected={filterLocations}
                  onToggle={(key) =>
                    setFilterLocations((prev) => toggleFilterValue(prev, key))
                  }
                />
              )}
              {availableFilters.companyTypes.length > 0 && (
                <FilterOptionList
                  title="Company type"
                  options={availableFilters.companyTypes}
                  selected={filterCompanyTypes}
                  onToggle={(key) =>
                    setFilterCompanyTypes((prev) =>
                      toggleFilterValue(prev, key)
                    )
                  }
                />
              )}
              <FilterOptionList
                title="Department"
                options={availableFilters.departments}
                selected={filterDepartments}
                onToggle={(key) =>
                  setFilterDepartments((prev) => toggleFilterValue(prev, key))
                }
              />
              {availableFilters.roles.length > 0 && (
                <FilterOptionList
                  title="Role"
                  options={availableFilters.roles}
                  selected={filterRoles}
                  onToggle={(key) =>
                    setFilterRoles((prev) => toggleFilterValue(prev, key))
                  }
                />
              )}
              <FilterOptionList
                title="Type"
                options={availableFilters.types}
                selected={filterTypes}
                onToggle={(key) =>
                  setFilterTypes((prev) => toggleFilterValue(prev, key))
                }
              />
              <FilterOptionList
                title="Education"
                options={availableFilters.educations}
                selected={filterEducations}
                onToggle={(key) =>
                  setFilterEducations((prev) => toggleFilterValue(prev, key))
                }
              />
              {availableFilters.durations.length > 0 && (
                <FilterOptionList
                  title="Duration"
                  options={availableFilters.durations}
                  selected={filterDurations}
                  onToggle={(key) =>
                    setFilterDurations((prev) => toggleFilterValue(prev, key))
                  }
                />
              )}
            </CatalogFilters>

            <div className="is-results">
              <div className="is-results-bar">
                <h2>
                  {loading
                    ? "Loading internships…"
                    : `${filteredInternships.length} internship${
                        filteredInternships.length === 1 ? "" : "s"
                      } found`}
                </h2>
              </div>

              {loading && (
                <div className="is-empty">
                  <div className="spinner-border text-primary" role="status" />
                </div>
              )}

              {!loading && filteredInternships.length === 0 && (
                <div className="is-empty">
                  <h3>No internships found</h3>
                  <p>Try adjusting your search or filters.</p>
                  <button
                    type="button"
                    className="is-search-btn"
                    onClick={clearFilterInputs}
                  >
                    Clear filters
                  </button>
                </div>
              )}

              {!loading && filteredInternships.length > 0 && (
                <div className="is-list">
                  {filteredInternships.map((internship) => {
                    const companyName =
                      internship.company?.company_name || "Company";
                    const initial = companyName.charAt(0).toUpperCase();
                    const skills = skillList(internship.skills);

                    return (
                      <article
                        key={internship.internship_id}
                        className="is-card"
                        onClick={() =>
                          handleCardClick(internship.internship_id)
                        }
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleCardClick(internship.internship_id);
                          }
                        }}
                      >
                        <div className="is-card-logo" aria-hidden="true">
                          {internship.company?.company_logo ? (
                            <img
                              src={
                                internship.company.company_logo.startsWith("http")
                                  ? internship.company.company_logo
                                  : `${AxiosInstance.defaults.baseURL}/media/${String(
                                      internship.company.company_logo
                                    ).replace(/\\/g, "/")}`
                              }
                              alt=""
                              onError={(e) => {
                                e.target.style.display = "none";
                                e.target.nextSibling.style.display = "flex";
                              }}
                            />
                          ) : null}
                          <span
                            className="is-card-initial"
                            style={{
                              display: internship.company?.company_logo
                                ? "none"
                                : "flex",
                            }}
                          >
                            {initial}
                          </span>
                        </div>

                        <div className="is-card-body">
                          <div className="is-card-top">
                            <div>
                              <h3 className="is-card-title">
                                {internship.role}
                              </h3>
                              <p className="is-card-company">{companyName}</p>
                            </div>
                            {internship.status && (
                              <span className="is-status">
                                {internship.status}
                              </span>
                            )}
                          </div>

                          <div className="is-card-meta">
                            <span>
                              <FiMapPin /> {internship.location || "N/A"}
                            </span>
                            <span>
                              <FiHome /> {internship.work_mode || "N/A"}
                            </span>
                            <span>
                              <FiBriefcase />{" "}
                              {internship.internship_type || "Internship"}
                            </span>
                            <span>
                              <FiClock /> {internship.duration || "N/A"}
                            </span>
                            <span>
                              <HiOutlineCurrencyRupee />{" "}
                              {internship.stipend || "Unpaid"}
                            </span>
                          </div>

                          {skills.length > 0 && (
                            <div className="is-skills">
                              {skills.map((skill) => (
                                <span key={skill}>{skill}</span>
                              ))}
                            </div>
                          )}

                          <div className="is-card-footer">
                            <span className="is-apply-by">
                              Apply by {internship.apply_by || "N/A"}
                            </span>
                            {appliedInternshipIds.has(
                              Number(internship.internship_id)
                            ) ? (
                              <button
                                type="button"
                                className="is-apply-btn applied"
                                disabled
                              >
                                Applied
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="is-apply-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedInternship(internship);
                                  setShowModal(true);
                                  setErrorMessage("");
                                }}
                              >
                                Apply now
                              </button>
                            )}
                          </div>
                        </div>
                      </article>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showModal && selectedInternship && (
        <div
          className="modal show fade d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content is-modal">
              <div className="modal-header">
                <h5 className="modal-title">
                  {!traineeId
                    ? isSigningIn
                      ? "Apply"
                      : "Register"
                    : "Complete Your Application"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                />
              </div>
              <div className="modal-body">
                <form onSubmit={handleFormSubmit}>
                  {errorMessage && (
                    <div className="alert alert-danger">{errorMessage}</div>
                  )}

                  {!traineeId ? (
                    isSigningIn ? (
                      <>
                        <div className="mb-3">
                          <label>Email or mobile number</label>
                          <input
                            type="text"
                            name="email"
                            className="form-control"
                            placeholder="Enter email or mobile number"
                            value={formData.email}
                            onChange={handleInputChange}
                            autoComplete="username"
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label>Password</label>
                          <input
                            type="password"
                            name="password"
                            className="form-control"
                            value={formData.password}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <button
                          type="submit"
                          className="btn btn-primary w-100 mb-2"
                        >
                          Sign In
                        </button>
                        <div>
                          <small>
                            Don't have an account?{" "}
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              onClick={() => setIsSigningIn(false)}
                            >
                              Register
                            </button>
                          </small>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="row mb-3">
                          <div className="col">
                            <label>First Name</label>
                            <input
                              type="text"
                              name="first_name"
                              className="form-control"
                              value={formData.first_name}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                          <div className="col">
                            <label>Last Name</label>
                            <input
                              type="text"
                              name="last_name"
                              className="form-control"
                              value={formData.last_name}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col">
                            <label>Email</label>
                            <input
                              type="email"
                              name="email"
                              className="form-control"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                          <div className="col">
                            <label>Mobile No</label>
                            <input
                              type="tel"
                              name="mobile_no"
                              className="form-control"
                              value={formData.mobile_no}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="mb-3">
                          <label>Password</label>
                          <input
                            type="password"
                            name="password"
                            className="form-control"
                            value={formData.password}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label>Confirm Password</label>
                          <input
                            type="password"
                            name="confirmPassword"
                            className="form-control"
                            value={formData.confirmPassword}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <button
                          type="submit"
                          className="btn btn-primary w-100 mb-2"
                        >
                          Register
                        </button>
                        <div>
                          <small>
                            Already have an account?{" "}
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              onClick={() => setIsSigningIn(true)}
                            >
                              Sign In
                            </button>
                          </small>
                        </div>
                      </>
                    )
                  ) : (
                    <>
                      <div className="mb-3">
                        <label>Resume (PDF, DOC, DOCX)</label>
                        <input
                          type="file"
                          className="form-control"
                          accept=".pdf,.doc,.docx"
                          onChange={handleFileChange}
                          required
                        />
                      </div>
                      <button type="submit" className="btn btn-primary w-100">
                        Submit Application
                      </button>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footers />
    </div>
  );
}
